import { StepEnum } from '../../../../../components-library/checkout/CheckoutSteps';

export default {
  steps: {
    [StepEnum.OrderConfirmation]: 'Review Order',
    [StepEnum.OrderPayment]: 'Payment',
  },
};
